export default {
  event: function event(el, _event, handler) {
    if (el.addEventListener) el.addEventListener(_event, handler, false);else if (el.attachEvent) el.attachEvent("on" + _event, handler);
  },
  eventRemove: function eventRemove(el, event, handler) {
    if (el.removeEventListener) el.removeEventListener(event, handler, false);else if (el.detachEvent) el.detachEvent("on" + event, handler);
  }
};